import { z } from 'zod'

export const kakaoOauthTokenSuccessResponseSchema = z.object({
  token_type: z.string(),
  access_token: z.string(),
  id_token: z.string().optional(),
  expires_in: z.number(),
  refresh_token: z.string(),
  refresh_token_expires_in: z.number(),
  scope: z.string().optional(),
})

export const kakaoOauthTokenFailureResponseSchema = z.object({
  error: z.string(),
  error_description: z.string(),
  error_code: z.string(),
})

export type KakaoOAuthTokenSuccessResponse = z.infer<typeof kakaoOauthTokenSuccessResponseSchema>
export type KakaoOAuthTokenFailureResponse = z.infer<typeof kakaoOauthTokenFailureResponseSchema>
